export { default } from './MascotBanner';
